import {
  GET_SUMMARY_WATCHER,
  GET_SUMMARY_SUCCESS,
  GET_SUMMARY_FAILED,
  UPLOAD_TEMPLATE_WATCHER,
  UPLOAD_TEMPLATE_SUCCESS,
  UPLOAD_TEMPLATE_FAILED,
  SAVE_EXCEL_WATCHER,
  SAVE_EXCEL_SUCCESS,
  SAVE_EXCEL_FAILED,
  SAVE_EXCEL_PROGRESS,
} from "./constants"

// SAVE EXCEL COLLABORATORS
export function saveExcelWatcher(payload) {
  return {
    type: SAVE_EXCEL_WATCHER,
    payload,
  }
}

export function saveExcelSuccess(payload) {
  return {
    type: SAVE_EXCEL_SUCCESS,
    payload,
  }
}

export function saveExcelFailed() {
  return { type: SAVE_EXCEL_FAILED }
}

export function saveExcelProgress(payload) {
  return {
    type: SAVE_EXCEL_PROGRESS,
    payload,
  }
}

export function getSummaryWatcher() {
  return { type: GET_SUMMARY_WATCHER }
}

export function getSummarySuccess(payload) {
  return {
    type: GET_SUMMARY_SUCCESS,
    payload,
  }
}

export function getSummaryFailed() {
  return { type: GET_SUMMARY_FAILED }
}

export function uploadTemplateWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_WATCHER,
    payload,
  }
}

export function uploadTemplateSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_SUCCESS,
    payload,
  }
}

export function uploadTemplateFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_FAILED,
    payload,
  }
}
